import React from 'react'; 

const Landing = () => {
    return (
        <div className="landing pt4 vertical-center bg-dark">
            <div className="title message-bottom">
                <div className="typewriter-message">
                    <div>
                        <h3 className="bg-dark br3 ph2 tc" style={{fontSize: "2vw", fontWeight: 300}}>Hey there, welcome to my website!</h3>
                    </div>
                </div>
            </div>    
        </div>
    );
}

export default Landing; 